const PaymentMain = ({
  total = 0,
  email = "test_email_ja@gmail.com",
  products = "TEST PRODUCT",
  customerref = "1234567890",
  refno = new Date().getTime(),
  full_name = "test name",
}) => {
  return (
    <div className="hidden">
      <form
        method="post"
        action="https://www.thaiepay.com/epaylink/payment.aspx"
      >
        <input type="hidden" name="refno" value={refno} />
        <input type="hidden" name="merchantid" value="33636283" />
        {/* <input type="hidden" name="merchantid" value="46536705" /> */}
        <input type="hidden" name="customeremail" value={email} />
        <input type="hidden" name="customername" value={full_name} />
        <input type="hidden" name="cc" value="00" />
        <input type="hidden" name="productdetail" value={products} />
        <input type="hidden" name="total" value={total} />
        <input type="hidden" name="customerref" value={customerref} />
        <input
          type="submit"
          name="Submit"
          value="Confirm Order"
          id="button-submit"
        />
      </form>
    </div>
  );
};
export default PaymentMain;
